/**
 * Declarative list of assets to preload before the world is built.
 * Add textures / cube textures / glTF models here and they become available
 * via `experience.resources.items[name]` once `ready` fires.
 *
 * Files live in `/public` (referenced from the web root, e.g. `/textures/...`).
 */
export interface Source {
  name: string
  type: 'texture' | 'cubeTexture' | 'gltfModel'
  path: string | string[]
}

export const sources: Source[] = [
  // Example — drop the files in /public/textures and uncomment:
  // {
  //   name: 'environmentMap',
  //   type: 'cubeTexture',
  //   path: [
  //     '/textures/environment/px.jpg',
  //     '/textures/environment/nx.jpg',
  //     '/textures/environment/py.jpg',
  //     '/textures/environment/ny.jpg',
  //     '/textures/environment/pz.jpg',
  //     '/textures/environment/nz.jpg',
  //   ],
  // },
  // {
  //   name: 'helmet',
  //   type: 'gltfModel',
  //   path: '/models/helmet/DamagedHelmet.gltf',
  // },
]
